import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 36, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children }) {
  return (
    <p className="text-[11px] font-sans font-bold uppercase tracking-[0.3em] text-gold-glow/90 flex items-center gap-3">
      <span className="inline-block w-8 h-px bg-gold/50" />
      {children}
    </p>
  );
}

export function SectionTitle({ children, className = "" }) {
  return (
    <h2 className={`font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-cream text-balance ${className}`}>
      {children}
    </h2>
  );
}
